"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhoneLink = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var libphonenumber_js_1 = require("libphonenumber-js");

var Link_1 = require("./Link");

var PhoneLink = function PhoneLink(_a) {
  var number = _a.number,
      formatter = _a.formatter,
      _a$autoResize = _a.autoResize,
      autoResize = _a$autoResize === void 0 ? true : _a$autoResize,
      props = __rest(_a, ["number", "formatter", "autoResize"]); // Mexico,Canada,US national numbers are all 10 digits


  var NUMBERLENGTH = 10; // removes all nom numeric characters

  var strippedNumber = "+".concat(number.replace(/\D/g, ""));

  var getNumberToDisplay = function getNumberToDisplay() {
    var parsedNum = (0, libphonenumber_js_1.parsePhoneNumber)(strippedNumber);
    var country = parsedNum.country,
        nationalNumber = parsedNum.nationalNumber;
    var valid = !!country && nationalNumber.length === NUMBERLENGTH;
    var displayNum = valid && parsedNum.formatInternational() || number;
    return {
      valid: valid,
      displayNum: displayNum,
      nationalNumber: nationalNumber
    };
  };

  var applyFormatter = function applyFormatter() {
    var displayString = "",
        index = 0;

    if (formatter && formatter.length) {
      var _iterator = _createForOfIteratorHelper(formatter),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;
          displayString += char !== "#" ? char : "".concat(nationalNumber[index++]);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    return displayString;
  };

  var _getNumberToDisplay = getNumberToDisplay(),
      valid = _getNumberToDisplay.valid,
      displayNum = _getNumberToDisplay.displayNum,
      nationalNumber = _getNumberToDisplay.nationalNumber;

  return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
    children: [valid && (0, jsx_runtime_1.jsx)(Link_1.Link, Object.assign({
      gatsby: false,
      autoResize: autoResize,
      to: "tel:".concat(strippedNumber)
    }, props, {
      children: formatter && applyFormatter() || displayNum
    })), !valid && (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
      autoResize: autoResize,
      type: props.type,
      size: props.size,
      weight: props.weight,
      underline: props.underline,
      italic: props.italic,
      children: displayNum
    })]
  });
};

exports.PhoneLink = PhoneLink;